import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/home'
import Whole from '@/components/home/whole/whole'
import WholeMsg from '@/components/home/whole/wholeMsg'
import WholeList from '@/components/home/whole/wholeList'
import WholeDetail from '@/components/home/whole/wholeDetail'
import Deploy from '@/components/home/whole/deploy'
import Design from '@/components/home/design'
import Bid from '@/components/home/bid'
import BidDetail from '@/components/home/bidDetail'
import HomeSever from '@/components/home/home_sever'
import HomeClass from '@/components/home/home_class'
import HomeUndete from '@/components/home/home_undete'
import Quick from '@/components/home/quick'
import Release from '@/components/home/release'
import Exh from '@/components/home/exhibition'
import Goods from '@/components/goods/goods'
import Xiaoxi from '../../src/components/min/xiaoxizhongxin/xiaoxi'
import SerClass from '@/components/goods/serClass'
import Detail from '@/components/detail/detail'
import Comment from '@/components/detail/comment'
import Carts from '@/components/carts/carts'
import Pays from '@/components/carts/pays'
import Sucess from '@/components/carts/sucess'
import Login from '@/components/login/login'
import wxphone from '@/components/wxphone/wxphone'
import Logon from '@/components/logon/logon'
import _Treaty from '@/components/logon/_treaty'
import Password from '@/components/password/password'
import Class from '@/components/class/class'
import Ser_detail from '@/components/class/ser_detail'
import Pages from '@/components/pages/pages'
import Brand from '@/components/serBrand/serBrand'
import Serch from '@/components/serch/serch'
import BrandDetail from '@/components/brandDetail/brandDetail'
import Address from '@/components/address/address'
import Min from '@/components/min/min'
import Order from '@/components/min/order'
import Seting from '@/components/min/setting/seting'
import Name from '@/components/min/setting/name'
import Change_pswd from '@/components/min/setting/Change_pswd'
import Account from '@/components/min/setting/account'
import Destroy from '@/components/min/setting/destroy'
import Sale from '@/components/min/sale'
import Apply from '@/components/min/apply'
import Assess from '@/components/min/assess'
import Collect from '@/components/min/collect'
import Site from '@/components/min/site'
import Shop from '@/components/min/shopAdd'
import ShopUpdate from '@/components/min/shopUpdate'
import OrderDetail from '@/components/min/orderDetails'
import Wallet from '@/components/min/wallet'
import invitationnumber from '@/components/min/invitationnumber'
import personnelmsg from '@/components/min/personnelmsg'
import directinvitation from '@/components/min/directinvitation'
import Record from '@/components/min/record'
import About from '@/components/min/about/about'
import Idle from '@/components/min/idle'
import Information from '@/components/min/about/information'
import NewList from '@/components/min/about/newList'
import Profile from '@/components/min/about/profile'
import Treaty from '@/components/min/about/treaty'
import UpdateLdle from '@/components/min/updateLdle'
import UndeteDteil from '@/components/home/undeteDteil'
import Pos from '@/components/home/pos'
import Chain from '@/components/class/chain'
import IdleNone from '@/components/min/idleNone'
import Score from '@/components/class/score'
import TpComment from '@/components/class/tpcomment'
import Limit from '@/components/home/limit'
import LimitDetail from '@/components/home/limitDetail'
import LimitChain from '@/components/home/limitChain'
import Offline from '@/components/min/OfflineList/offline'
import OffList from '@/components/min/OfflineList/offList'
import OffDetail from '@/components/min/offlineList/offDetail'
import yuyueshangmen from '@/components/yuyueshangmen/yuyueshangmen'
import Detaill from '@/components/detaill/detaill'
import Aftersale from '@/components/aftersale/aftersale'
import browsinghistory from '@/components/browsinghistory/browsinghistory'
import invoice from '@/components/invoice/invoice'
import overinvoices from '@/components/overinvoices/overinvoices'
import contract from '@/components/contract/contract'
import contractain from '@/components/contractain/contractain'
import contractPreview from '@/components/contractPreview/contractPreview'
import mycontract from '@/components/mycontract/mycontract'
import QRcode from '@/components/QRcode/QRcode'
import packages from '@/components/packages/packages'
import packlist from '@/components/packages/packlist'
import wholesubmit from '@/components/wholesubmit/wholesubmit'
import programme from '@/components/programme/programme'
import compomtnes from '@/components/programme/compomtnes'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [{
			path: '/',
			redirect: '/Home'
		}, {
			path: '/home',
			name: 'home',
			component: Home,
			meta: {
				keepAlive: true,
				isBack: false,
			}
		}, {
			path: '/whole',
			name: 'whole',
			component: Whole
		}, {
			path: '/wholeList',
			name: 'wholeList',
			component: WholeList
		}, {
			path: '/wholeMsg',
			name: 'wholeMsg',
			component: WholeMsg
		},
		{
			path: '/wholeDetail',
			name: 'wholeDetail',
			component: WholeDetail
		}, {
			path: '/deploy',
			name: 'deploy',
			component: Deploy
		}, {
			path: '/design',
			name: 'design',
			component: Design
		}, {
			path: '/goods',
			name: 'goods',
			component: Goods
		}, {
			path: '/serClass',
			name: 'serClass',
			component: SerClass,
			meta: {
				keepAlive: true,
				isBack: false,
			}
		}, {
			path: '/detail',
			name: 'detail',
			component: Detail,
			meta: {
				keepAlive: false
			}
		}, {
			path: '/comment',
			name: 'comment',
			component: Comment
		}, {
			path: '/carts',
			name: 'carts',
			component: Carts
		}, {
			path: '/sucess',
			name: 'sucess',
			component: Sucess
		}, {
			path: '/Class',
			name: 'class',
			component: Class
		}, {
			path: '/Ser_detail',
			name: 'Ser_detail',
			component: Ser_detail,
			meta: {
				keepAlive: true,
				isBack: false,
			}
		}, {
			path: '/min',
			name: 'min',
			component: Min
		}, {
			path: '/login',
			name: 'login',
			component: Login
		}, {
			path: '/logon',
			name: 'logon',
			component: Logon
		}, {
			path: '/wxphone',
			name: 'wxphone',
			component: wxphone
		}, {
			path: '/_treaty',
			name: '_treaty',
			component: _Treaty
		}, {
			path: '/password',
			name: 'password',
			component: Password
		}, {
			path: '/pages',
			name: 'pages',
			component: Pages,
			meta: {
				keepAlive: true,
				isBack: false,
			}
		}, {
			path: '/brand',
			name: 'brand',
			component: Brand,
			meta: {
				keepAlive: true,
				isBack: false,
			}
		}, {
			path: '/serch',
			name: 'serch',
			component: Serch
		}, {
			path: '/brandDetail',
			name: 'brandDetail',
			component: BrandDetail,
			meta: {
				keepAlive: true,
				isBack: false,
			}
		}, {
			path: '/address',
			name: 'address',
			component: Address
		}, {
			path: '/pays',
			name: 'pays',
			component: Pays
		}, {
			path: '/order',
			name: 'order',
			component: Order
		}, {
			path: '/seting',
			name: 'seting',
			component: Seting
		}, {
			path: '/name',
			name: 'name',
			component: Name
		}, {
			path: '/change_pswd',
			name: 'change_pswd',
			component: Change_pswd
		}, {
			path: '/account',
			name: 'account',
			component: Account
		}, {
			path: '/destroy',
			name: 'destroy',
			component: Destroy
		}, {
			path: '/sale',
			name: 'sale',
			component: Sale
		},
		{
			path: '/yuyueshangmen',
			name: 'yuyueshangmen',
			component: yuyueshangmen
		},

		{
			path: '/apply',
			name: 'apply',
			component: Apply
		}, {
			path: '/assess',
			name: 'assess',
			component: Assess
		}, {
			path: '/collect',
			name: 'collect',
			component: Collect
		}, {
			path: '/orderDetail',
			name: 'orderDetail',
			component: OrderDetail
		}, {
			path: '/bid',
			name: 'bid',
			component: Bid,
			meta: {
				keepAlive: true,
				isBack: false,
			}
		}, {
			path: '/bidDetail',
			name: 'bidDetail',
			component: BidDetail
		}, {
			path: '/site',
			name: 'site',
			component: Site
		}, {
			path: '/wallet',
			name: 'wallet',
			component: Wallet
		}, {
			path: '/invitationnumber',
			name: 'invitationnumber',
			component: invitationnumber
		}, {
			path: '/personnelmsg',
			name: 'personnelmsg',
			component: personnelmsg
		}, {
			path: '/directinvitation',
			name: 'directinvitation',
			component: directinvitation
		}, {
			path: '/offline',
			name: 'offline',
			component: Offline
		}, {
			path: '/about',
			name: 'about',
			component: About
		}, {
			path: '/information',
			name: 'information',
			component: Information
		}, {
			path: '/newList',
			name: 'newList',
			component: NewList
		}, {
			path: '/profile',
			name: 'profile',
			component: Profile
		}, {
			path: '/treaty',
			name: 'treaty',
			component: Treaty
		}, {
			path: '/record',
			name: 'record',
			component: Record
		}, {
			path: '/home_sever',
			name: 'home_sever',
			component: HomeSever,
			meta: {
				keepAlive: true,
				isBack: false,
			}
		}, {
			path: '/home_class',
			name: 'home_class',
			component: HomeClass,
			meta: {
				keepAlive: true,
				isBack: false,
			},
		}, {
			path: '/exh',
			name: 'exh',
			component: Exh
		}, {
			path: '/home_undete',
			name: 'home_undete',
			component: HomeUndete,
			meta: {
				keepAlive: true,
				isBack: false,
			},
		}, {
			path: '/quick',
			name: 'quick',
			component: Quick
		}, {
			path: '/release',
			name: 'release',
			component: Release
		}, {
			path: '/undeteDteil',
			name: 'undeteDteil',
			component: UndeteDteil
		}, {
			path: '/pos',
			name: 'pos',
			component: Pos
		}, {
			path: '/idle',
			name: 'idle',
			component: Idle
		}, {
			path: '/updateLdle',
			name: 'updateLdle',
			component: UpdateLdle
		}, {
			path: '/shop',
			name: 'shop',
			component: Shop
		}, {
			path: '/shopUpdate',
			name: 'shopUpdate',
			component: ShopUpdate
		}, {
			path: '/chain',
			name: 'chain',
			component: Chain
		}, {
			path: '/idleNone',
			name: 'idleNone',
			component: IdleNone
		}, {
			path: '/score',
			name: 'score',
			component: Score
		}, {
			path: '/tpcomment',
			name: 'tpcomment',
			component: TpComment
		}, {
			path: '/limit',
			name: 'limit',
			component: Limit,
		}, {
			path: '/limitDetail',
			name: 'limitDetail',
			component: LimitDetail,
		}, {
			path: '/limitChain',
			name: 'limitChain',
			component: LimitChain
		}, {
			path: '/offList',
			name: 'offList',
			component: OffList
		}, {
			path: '/offDetail',
			name: 'offDetail',
			component: OffDetail,
		}, {
			path: '/detaill',
			name: 'detaill',
			component: Detaill
		}, {
			path: '/detaill',
			name: 'detaill',
			component: Detaill
		}, {
			path: '/xiaoxi',
			name: 'xiaoxi',
			component: Xiaoxi
		}, {
			path: '/aftersale',
			name: 'aftersale',
			component: Aftersale,
		}, {
			path: '/browsinghistory',
			name: 'browsinghistory',
			component: browsinghistory,
		}, {
			path: '/invoice',
			name: 'invoice',
			component: invoice,
		}, {
			path: '/overinvoices',
			name: 'overinvoices',
			component: overinvoices,
		}, {
			path: '/contract',
			name: 'contract',
			component: contract,
		}, {
			path: '/contractain',
			name: 'contractain',
			component: contractain,
		}, {
			path: '/contractPreview',
			name: 'contractPreview',
			component: contractPreview,
		}, {
			path: '/mycontract',
			name: 'mycontract',
			component: mycontract,
		}, {
			path: '/QRcode',
			name: 'QRcode',
			component: QRcode,
		}, {
			path: '/packages',
			name: 'packages',
			component: packages,
			meta: {
				keepAlive: true,
				isBack: false,
			},
		}, {
			path: '/wholesubmit',
			name: 'wholesubmit',
			component: wholesubmit,
		}, {
			path: '/packlist',
			name: 'packlist',
			component: packlist,
		}, {
			path: '/programme',
			name: 'programme',
			component: programme,
		},, {
			path: '/compomtnes',
			name: 'compomtnes',
			component: compomtnes,
		},
	],
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {
				x: 0,
				y: 0
			}

		}
	},
	scrollBehaviorbeforeRouteLeave(to, from, next) {
		// 组件离开的时候，获取页面滚动高度
		this.offsetTop = document.querySelector('#app').scrollTop
		next()
	},

})



// WEBPACK FOOTER //
// ./src/router/index.js